var link = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/link.jpg';
var ghost = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/ghost.jpg';
var ghostDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/ghost_detail.jpg';
var ring = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/ring.jpg';
var amoeba = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/amoeba.jpg';
var amoebaDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/amoeba_detail.jpg';
var backfloat = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/backfloat.jpg';
var backfloatDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/backfloat_detail.jpg';
var exhale = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-bts/exhale.jpg';

export const allImagesDesktopOrderBts = [
    [/*COLUMN 1*/
        [
            {
                name: link,
                artistName: "Lorraine Shemesh",
                title: "Link",
                year: "1999",
                dimensions: "67 x 66 3/4 in., o/c",
                link: "bts1",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: ghost,
                artistName: "Lorraine Shemesh",
                title: "Ghost",
                year: "2006",
                dimensions: "72 x 64 in., o/c",
                link: "bts2",
                privateCollection: "Private Collection"
            },
            {
                name: ghostDetail1,
                artistName: "Lorraine Shemesh",
                title: "Ghost - detail",
                year: "2006",
                dimensions: "72 x 64 in., o/c",
                link: "bts3",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: ring,
                artistName: "Lorraine Shemesh",
                title: "Ring",
                year: "1997",
                dimensions: "46 x 36 in.,o/c",
                link: "bts4",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: amoeba,
                artistName: "Lorraine Shemesh",
                title: "Amoeba",
                year: "2005",
                dimensions: "71 1/2 x 61 1/2 in., o/c",
                link: "bts5",
                privateCollection: "Private Collection"
            },
            {
                name: amoebaDetail1,
                artistName: "Lorraine Shemesh",
                title: "Amoeba - detail",
                year: "2005",
                dimensions: "71 1/2 x 61 1/2 in., o/c",
                link: "bts6",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: backfloat,
                artistName: "Lorraine Shemesh",
                title: "Back Float",
                year: "1991",
                dimensions: "72 x 78 in., o/c",
                link: "bts7",
                privateCollection: "Private Collection"
            },
            {
                name: backfloatDetail1,
                artistName: "Lorraine Shemesh",
                title: "Back Float - detail",
                year: "1991",
                dimensions: "72 x 78 in., o/c",
                link: "bts8",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: exhale,
                artistName: "Lorraine Shemesh",
                title: "Exhale",
                year: "1995",
                dimensions: "69 x 80 in., o/c",
                link: "bts9",
                privateCollection: "Private Collection"
            }
        ]
    ]          
]

export const allImagesMobileOrderBts = [
    [{
        name: link,
        artistName: "Lorraine Shemesh",
        title: "Link",
        year: "1999",
        dimensions: "67 x 66 3/4 in., o/c",
        link: "bts1",
        privateCollection: "Private Collection"
    },
    {
        name: ghost,
        artistName: "Lorraine Shemesh",
        title: "Ghost",
        year: "2006",
        dimensions: "72 x 64 in., o/c",
        link: "bts2",
        privateCollection: "Private Collection"
    },
    {
        name: ghostDetail1,
        artistName: "Lorraine Shemesh",
        title: "Ghost - detail",
        year: "2006",
        dimensions: "72 x 64 in., o/c",
        link: "bts3",
        privateCollection: "Private Collection"
    },
    {
        name: ring,
        artistName: "Lorraine Shemesh",
        title: "Ring",
        year: "1997",
        dimensions: "46 x 36 in.,o/c",
        link: "bts4",
        privateCollection: "Private Collection"
    },
    {
        name: amoeba,
        artistName: "Lorraine Shemesh",
        title: "Amoeba",
        year: "2005",
        dimensions: "71 1/2 x 61 1/2 in., o/c",
        link: "bts5",
        privateCollection: "Private Collection"
    },
    {
        name: amoebaDetail1,
        artistName: "Lorraine Shemesh",
        title: "Amoeba - detail",
        year: "2005",
        dimensions: "71 1/2 x 61 1/2 in., o/c",
        link: "bts6",
        privateCollection: "Private Collection"
    },
    {
        name: backfloat,
        artistName: "Lorraine Shemesh",
        title: "Back Float",
        year: "1991",
        dimensions: "72 x 78 in., o/c",
        link: "bts7",
        privateCollection: "Private Collection"
    },
    {
        name: backfloatDetail1,
        artistName: "Lorraine Shemesh",
        title: "Back Float - detail",
        year: "1991",
        dimensions: "72 x 78 in., o/c",
        link: "bts8",
        privateCollection: "Private Collection"
    },
    {
        name: exhale,
        artistName: "Lorraine Shemesh",
        title: "Exhale",
        year: "1995",
        dimensions: "69 x 80 in., o/c",
        link: "bts9",
        privateCollection: "Private Collection"
    }]      
]
